import { useRef, useState } from "react";
import { useQuery } from "@apollo/client";
import { Pagination, Spinner } from "@aqar-app/aqar-design-system";
import { GET_USER_FEES } from "../../graphql/queries/user";
import { useAuthState } from "../../contexts/auth/auth.provider";
import FeeCard from "../../components/FeeCard/FeeCard";
import config from "../../common/config";
import classes from "./userFees.module.scss";

function UserFees() {
  const { token } = useAuthState();
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedInvoiceIndex, setSelectedInvoiceIndex] = useState(null);
  const FeesContainer = useRef();
  const {
    data: userFees,
    loading,
    refetch,
  } = useQuery(GET_USER_FEES, {
    context: { token },
  });

  const {
    User: { getRecurringFees },
  } = userFees || { User: {} };
  const { list, total } = getRecurringFees || {};

  const pageChangeHandler = (pageNbr) => {
    setCurrentPage(pageNbr);
    refetch({ offset: (pageNbr - 1) * config.USER_FEES_PAGE_SIZE });
    FeesContainer.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const renderPagination = () => {
    const paginationProps = {
      total,
      currentPage,
      itemsPerPage: config.USER_FEES_PAGE_SIZE,
      onPageChange: pageChangeHandler,
    };

    return <Pagination {...paginationProps} />;
  };

  const handleInvoiceClick = (index) => {
    if (index === selectedInvoiceIndex) {
      setSelectedInvoiceIndex(null);
      return;
    }
    setSelectedInvoiceIndex(index);
  };

  return (
    <div className={classes.container}>
      {list?.length ? (
        <div ref={FeesContainer} className={classes.feesList}>
          {list.map((fee, index) => (
            <div key={fee.payment_id} className={classes.feeContainer}>
              <FeeCard
                index={index}
                fee={fee}
                onClick={() => handleInvoiceClick(index)}
              />
              {selectedInvoiceIndex === index && (
                <iframe
                  src={`${config.AQAR_WEB_EP}/invoice?token=${token}&type=recurring_fee&payment_id=${fee.payment_id}`}
                  title="Aqar Invoice"
                  width="100%"
                  style={{ height: "40pc" }}
                  frameBorder="0"
                />
              )}
            </div>
          ))}
        </div>
      ) : (
        <div>
          {loading ? (
            <div className={classes.spinnerWrapper}>
              <Spinner className={classes.spinner3rem} />
            </div>
          ) : (
            <div className={classes.emptyListingsNote}>لا يوجد مدفوعات.</div>
          )}
        </div>
      )}
      {total && refetch ? <div>{renderPagination()}</div> : null}
    </div>
  );
}

export default UserFees;
